import './stark-product-cart-base.js?v=2026080409';

const BOLETA_NOTE = 'Documento Tributario: Boleta';
const starkCartConfig = window.StarkThemeConfig?.cart || {};
const escapeCartHtml = (value) =>
  String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
let state = { type: 'boleta', rut: '' };
let savePromise = null;
let checkoutInProgress = false;
let initialized = false;

function parseNote(note = '') {
  const invoice = /^Documento Tributario:\s*Factura/im.test(note);
  const rut = note.match(/^RUT:\s*(.+)$/im)?.[1]?.trim() || '';
  return { type: invoice ? 'factura' : 'boleta', rut };
}

function buildNote() {
  return state.type === 'factura'
    ? `Documento Tributario: Factura\nRUT: ${state.rut.trim().toUpperCase()}`
    : BOLETA_NOTE;
}

function isValid() {
  return state.type === 'boleta' || Boolean(state.rut.trim());
}

function updateControls() {
  document.querySelectorAll('[data-tax-document]').forEach((root) => {
    const isInvoice = state.type === 'factura';
    const boleta = root.querySelector('[data-tax-type="boleta"]');
    const factura = root.querySelector('[data-tax-type="factura"]');
    const rutWrap = root.querySelector('[data-tax-rut-wrap]');
    const rut = root.querySelector('[data-tax-rut]');
    const error = root.querySelector('[data-tax-error]');
    if (boleta) boleta.checked = !isInvoice;
    if (factura) factura.checked = isInvoice;
    if (rutWrap) rutWrap.hidden = !isInvoice;
    if (rut) {
      rut.required = isInvoice;
      if (rut.value !== state.rut) rut.value = state.rut;
    }
    if (error) error.hidden = isValid();
  });

  document.querySelectorAll('[name="checkout"]').forEach((button) => {
    button.disabled = !isValid() || checkoutInProgress;
  });

  document.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
    const blocked = !isValid() || Boolean(savePromise) || checkoutInProgress;
    buttons.style.pointerEvents = blocked ? 'none' : '';
    buttons.style.opacity = blocked ? '0.5' : '';
  });
}

async function saveNote() {
  if (!isValid()) throw new Error('RUT obligatorio');
  if (savePromise) await savePromise;

  const note = buildNote();
  const url = `${window.Shopify?.routes?.root || '/'}cart/update.js`;
  savePromise = fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ note }),
  }).then(async (response) => {
    if (!response.ok) throw new Error(`No se pudo guardar la nota (${response.status})`);
    return response.json();
  }).finally(() => {
    savePromise = null;
    updateControls();
  });

  updateControls();
  return savePromise;
}

function selectorMarkup() {
  return `
    <div class="stark-tax-document" data-tax-document>
      <p class="stark-tax-document__title">${escapeCartHtml(starkCartConfig.documentTitle || 'Boleta o factura')} <span aria-hidden="true">*</span></p>
      <div class="stark-tax-document__options">
        <label><input type="radio" data-tax-type="boleta" name="stark_tax_document"> ${escapeCartHtml(starkCartConfig.receiptLabel || 'Boleta')}</label>
        <label><input type="radio" data-tax-type="factura" name="stark_tax_document"> ${escapeCartHtml(starkCartConfig.invoiceLabel || 'Factura')}</label>
      </div>
      <div class="stark-tax-document__rut" data-tax-rut-wrap hidden>
        <label>${escapeCartHtml(starkCartConfig.taxIdLabel || 'RUT')} <span aria-hidden="true">*</span></label>
        <input type="text" inputmode="text" placeholder="${escapeCartHtml(starkCartConfig.taxIdPlaceholder || '12.345.678-9')}" data-tax-rut>
      </div>
      <p class="stark-tax-document__error" data-tax-error hidden>${escapeCartHtml(starkCartConfig.taxIdError || 'Ingresa el RUT para solicitar factura.')}</p>
    </div>`;
}

function injectSelectors() {
  document.querySelectorAll('.cart-totals').forEach((totals) => {
    if (totals.querySelector('[data-tax-document]')) return;
    const actions = totals.querySelector('.cart-actions');
    const container = document.createElement('div');
    container.innerHTML = selectorMarkup().trim();
    const selector = container.firstElementChild;
    if (actions) actions.before(selector);
    else totals.prepend(selector);
  });
  updateControls();
}

function installStyles() {
  if (document.getElementById('stark-tax-document-style')) return;
  const style = document.createElement('style');
  style.id = 'stark-tax-document-style';
  style.textContent = `
    .stark-tax-document{width:100%;padding:16px 0;border-block-start:1px solid rgb(var(--color-foreground-rgb)/.15)}
    .stark-tax-document__title{margin:0 0 10px;font-weight:700}
    .stark-tax-document__options{display:flex;gap:20px;flex-wrap:wrap}
    .stark-tax-document__options label{display:flex;align-items:center;gap:7px;cursor:pointer}
    .stark-tax-document__rut{margin-top:14px}
    .stark-tax-document__rut label{display:block;margin-bottom:6px;font-weight:600}
    .stark-tax-document__rut input{width:100%;min-height:44px;padding:10px 12px;border:1px solid rgb(var(--color-foreground-rgb)/.25);border-radius:var(--style-border-radius-inputs,4px);background:var(--color-input-background);color:var(--color-input-text)}
    .stark-tax-document__error{margin:7px 0 0;color:#b00020;font-size:.9rem}
  `;
  document.head.appendChild(style);
}

function install() {
  if (!initialized) {
    initialized = true;
    const existingNote = document.querySelector('textarea[name="note"]')?.value || '';
    state = parseNote(existingNote);
    if (!existingNote.trim()) saveNote().catch(console.error);

    document.addEventListener('change', (event) => {
      const type = event.target.closest?.('[data-tax-type]')?.dataset.taxType;
      if (!type) return;
      state.type = type;
      updateControls();
      if (isValid()) saveNote().catch(console.error);
      else document.querySelector('[data-tax-rut]')?.focus();
    });

    document.addEventListener('input', (event) => {
      if (!event.target.matches?.('[data-tax-rut]')) return;
      state.rut = event.target.value;
      updateControls();
    });

    document.addEventListener('focusout', (event) => {
      if (!event.target.matches?.('[data-tax-rut]') || !isValid()) return;
      saveNote().catch(console.error);
    });

    document.addEventListener('click', async (event) => {
      const checkout = event.target.closest?.('[name="checkout"]');
      if (!checkout) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!isValid()) {
        const rut = document.querySelector('[data-tax-rut]');
        rut?.focus();
        rut?.reportValidity();
        updateControls();
        return;
      }

      if (checkoutInProgress) return;
      checkoutInProgress = true;
      updateControls();

      try {
        await saveNote();
        const checkoutUrl = `${window.Shopify?.routes?.root || '/'}checkout`;
        window.location.assign(checkoutUrl);
      } catch (error) {
        console.error(error);
        checkoutInProgress = false;
        updateControls();
        window.alert(starkCartConfig.saveError || 'No pudimos guardar la información. Intenta nuevamente.');
      }
    }, true);
  }

  installStyles();
  injectSelectors();

  const observer = new MutationObserver(() => injectSelectors());
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
else install();
